import {ValueObject} from '@s-ui/domain'

import {InvalidParamsSharedError} from '../../shared/Errors/InvalidParamsSharedError.js'

export class GetMakeModelSemanticsRequest extends ValueObject {
  #make
  #model

  static validate({make}) {
    if (!make) {
      throw InvalidParamsSharedError.create(`[GetMakeModelSemanticsRequest.validate] param make is required`)
    }
  }

  constructor({make, model}) {
    super()
    this.#make = make
    this.#model = model
  }

  get make() {
    return this.#make
  }

  get model() {
    return this.#model
  }

  static create({make, model} = {}) {
    GetMakeModelSemanticsRequest.validate({make})
    return new GetMakeModelSemanticsRequest({
      make,
      model
    })
  }

  get value() {
    return {
      make: this.#make,
      model: this.#model
    }
  }
}
